import { render, staticRenderFns } from "./BlogHome.vue?vue&type=template&id=70a1bf5e&scoped=true&"
import script from "./BlogHome.vue?vue&type=script&lang=js&"
export * from "./BlogHome.vue?vue&type=script&lang=js&"
import style0 from "./BlogHome.vue?vue&type=style&index=0&id=70a1bf5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a1bf5e",
  null
  
)

export default component.exports